

  import api from '@/api/axiosConfig';

  const createResponse = (data) => ({
    code: 200,
    result:data,
    timestamp: Date.now()
  })
  
  export const getHomeIndex = () =>   api.get('/home/index', { } )
export const getBanners=()=>api.get('/home/banners',{})
  export const getCompetitions = (size) => api.get('/competition/list', {pageSize:size })
  export const getCompetitionDetail = (id) =>api.get('/competition/detail', { params: { id } })
  export const getCompetitionSubList = (id) => api.get('/competition/subList', { params: { id } })
  export const getCompetitionSubDetail = (id) => api.get('/competition/subDetail', { params: { id } })

export const getCurrentConvention = () => api.get('/home/getCurrentConvention', {})
export const getShareConfig = (url) => api.get('/wx/share/getConfig', { params: { url } })
export default {
  getHomeIndex,
  getCompetitions,
  getCompetitionDetail,
  
  getCompetitionSubList,
  getCompetitionSubDetail,
  getBanners,
  getCurrentConvention,
  getShareConfig
}
